export const useScroll = ({ scrollDiv }: { scrollDiv: React.RefObject<HTMLDivElement> }) => {
    const toTop = () => {
        if (scrollDiv.current !== undefined && scrollDiv.current !== null)
            scrollDiv.current.scrollTop = 0
    }
    return { toTop }
}